import React, { PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useSession } from '../../entities/auth/hooks/useSession';
import { Loader } from '@gravity-ui/uikit';

type ProtectedRouteProps = PropsWithChildren;

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isActive, isLoading, isError, error } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && (!isActive || isError)) {
       const status = (error as any)?.response?.status;
       if (!isActive || status === 401 || status === 403) {
         navigate('/auth', { replace: true });
       } else if (isError) {
         console.error('Error checking session, but not 401/403:', error);
       }
    }
  }, [isLoading, isActive, isError, navigate, error]);

  if (isLoading) {
    return <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}><Loader size="l" /></div>;
  }

  if (isActive) {
    return <>{children}</>;
  }

  return null;
};
